import { PripomienkaValidateApi, PripomienkaValidationResponse } from 'pripomienky-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { pripomienkyPrefixPath } from '../../configuration/apiConfigurationConstants';

const client = new PripomienkaValidateApi(apiConfiguration(pripomienkyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const fetchPripomienkyValidation = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
):
  Promise<ClientResponse<PripomienkaValidationResponse>> => {
  const {
    data,
    status,
  } = await client.validatePripomienky(
    type,
    year,
    index,
    headers,
  );
  return {
    data,
    responseCode: status,
  };
};
